import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import { getCookie } from './util/tools/cookie'
import ElTreeSelect from 'el-tree-select'
import RouteView from '@/components/routeView'
import Modules from '@/components/modules'
import { resolveByString } from '@/router/dynamic-resolver'
// import Print from 'vue-print-nb'
import print from '@/util/print/print'

// 页面顶部进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VueSSE from 'vue-sse'

// Vue.prototype.$echarts = require('echarts')
Vue.config.productionTip = false

const WHITE_LIST = ['/login']

function safeJsonParse (val, fallback) {
  if (val == null) return fallback
  if (typeof val === 'object') return val
  try {
    return JSON.parse(val)
  } catch (e) {
    return fallback
  }
}

function trimLeadingSlash (path) {
  const s = String(path == null ? '' : path)
  if (s.indexOf('/') > -1) return s.substr(1)
  return s
}

function resolveRouteComponent (componentPath) {
  if (!componentPath) return ''
  if (typeof componentPath !== 'string') return componentPath
  const parts = componentPath.split('.')
  if (parts.length < 2) return resolveByString(componentPath)
  if (parts[0] === 'RouteView') {
    let mod = RouteView
    for (let i = 1; i < parts.length; i++) mod = mod ? mod[parts[i]] : ''
    return mod || ''
  }
  if (parts[0] === 'Modules') {
    let mod = Modules
    for (let i = 1; i < parts.length; i++) mod = mod ? mod[parts[i]] : ''
    return mod || ''
  }
  return resolveByString(componentPath)
}

function buildDynamicRoutes (menu) {
  const list = Array.isArray(menu) ? menu : []
  return list.map(item => {
    const module = resolveRouteComponent(item && item.component)
    const children0 = item && Array.isArray(item.children) ? item.children : []
    let children = children0.map(child => {
      return {
        path: trimLeadingSlash(child.path),
        name: trimLeadingSlash(child.path),
        meta: {
          name: child.name
        },
        component: resolveRouteComponent(child.component)
      }
    })
    if (children.length > 0) {
      children = [
        {
          path: '/',
          redirect: () => {
            const str = children[0].path
            return str.indexOf('/') > -1 ? str.substr(1) : str
          },
          hidden: true
        },
        ...children
      ]
    }
    return {
      path: item.path,
      meta: {
        name: item.name,
        keepAlive: true
      },
      component: module,
      children,
      name: item.path
    }
  })
}

function addTag (route) {
  if (route.path !== '/home/index') {
    store.dispatch('setRouteList', route)
    store.dispatch('addCachedView', route)
  }
}

// const router = new VueRouter({ router })
router.beforeEach((to, from, next) => {
  window.scroll(0, 0)
  NProgress.start()
  const q = to && to.query ? to.query : {}
  if (to.path === '/help/document' && q.from === 'bell') return next()
  if (WHITE_LIST.indexOf(to.path) >= 0) return next()

  const token = store.state.login.token
  if (!token) return next('/login')

  if (router.options.routes.length <= 4 && !store.state.login.isRouterSvae) {
    const rootMenu = safeJsonParse(store.state.login.rootMenu, [])
    const rt = buildDynamicRoutes(rootMenu)
    router.options.routes = router.options.routes.concat(rt)
    router.addRoutes(rt)
    return next(Object.assign({}, to, { replace: true }))
  }

  if (to.path.indexOf('/course/') > -1) {
    if (to.path === '/course/authority') {
      addTag(to)
      return next()
    }
    if (store.state.login.otoStatus === 'true' ||
      store.state.login.otoStatus === true) {
      addTag(to)
      return next()
    }
    return next('/course/authority')
  }

  addTag(to)
  next()
})
Vue.use(VueI18n)
Vue.use(ElementUI)
Vue.use(ElTreeSelect)
Vue.use(print)
Vue.use(VueSSE)

const i18n = new VueI18n({
  // 语言标识
  locale: getCookie('BELL_PLAY_LANG', 'zh'),
  // 通过切换locale的值来实现语言切换
  // this.$i18n.locale
  messages: {
    // 中文语言包
    zh: require('./util/i18n/zh.js'),
    // 英文语言包
    en: require('./util/i18n/en.js')
  }
})
router.afterEach(() => {
  NProgress.done()
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
